const SkeletonCard = () => {
    return (
      <div className="bg-white border border-[#EBEFF3] rounded-md p-5 animate-pulse">
        <div className="flex items-center justify-between pb-5 mb-[14px] border-b border-[#EBEFF3]">
          <div className="bg-gray-300 h-[27px] w-[80px] rounded-md" />
          <div className="flex items-center gap-2">
            <div className="h-4 w-[70px] bg-gray-300 rounded-md" />
            <div className="h-4 w-[10px] bg-gray-300 rounded-full" />
            <div className="h-4 w-[50px] bg-gray-300 rounded-md" />
          </div>
        </div>
        <div className="space-y-4">
          <div className="flex flex-col gap-2 border-b border-[#EBEFF3] pb-4 mb-4">
            <div className="h-5 w-[150px] bg-gray-300 rounded" />
            <div className="flex gap-3 items-center">
              <div className="h-4 w-[100px] bg-gray-300 rounded" />
              <div className="h-4 w-[8px] bg-gray-300 rounded-full" />
              <div className="h-4 w-[120px] bg-gray-300 rounded" />
            </div>
            <div className="flex justify-between w-full">
              <div className="h-4 w-[100px] bg-gray-300 rounded" />
              <div className="h-4 w-[80px] bg-gray-300 rounded" />
            </div>
          </div>
          <div className="space-y-2 border-b border-[#EBEFF3] pb-4 mb-4">
            <div className="h-4 w-[70px] bg-gray-300 rounded" />
            <div className="h-4 w-full bg-gray-300 rounded" />
          </div>
          <div className="flex justify-between items-center mb-4">
            <div className="h-5 w-[150px] bg-gray-300 rounded" />
            <div className="h-5 w-[70px] bg-gray-300 rounded" />
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="h-10 bg-gray-300 rounded-[10px]" />
            <div className="h-10 bg-gray-300 rounded-[10px]" />
          </div>
        </div>
      </div>
    );
  };

  export default SkeletonCard
  